"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantiationHook = void 0;
var InstantiationHook = /** @class */ (function () {
    function InstantiationHook() {
        this.hookRegistry = new Set(); // 用于注册对应ID的hook函数
    }
    InstantiationHook.prototype.addHook = function (hookPoint, callback) {
        this.hookRegistry.add({ hookPoint: hookPoint, callback: callback });
    };
    InstantiationHook.prototype.executeHooks = function (instance, point) {
        this.hookRegistry.forEach(function (hook) {
            var hookPoint = hook.hookPoint, callback = hook.callback;
            if (hookPoint === point) {
                callback(instance);
            }
        });
    };
    return InstantiationHook;
}());
exports.InstantiationHook = InstantiationHook;
//# sourceMappingURL=instantiation-hook.js.map